import { render, staticRenderFns } from "./TaxQsSubsidiesApply.vue?vue&type=template&id=b6813366&scoped=true&"
import script from "./TaxQsSubsidiesApply.vue?vue&type=script&lang=js&"
export * from "./TaxQsSubsidiesApply.vue?vue&type=script&lang=js&"
import style0 from "./TaxQsSubsidiesApply.vue?vue&type=style&index=0&id=b6813366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6813366",
  null
  
)

export default component.exports